<template>
  <div class="bg-sky-800 text-white py-16 px-[10%]" id="contact">
    <!-- Titel -->
    <div class="text-center mb-12">
      <h2 class="text-4xl lg:text-5xl font-bold mb-4">Contact</h2>
      <p class="text-lg text-sky-200">
        Neem contact met ons op voor al je vragen of meer informatie over onze diensten.
      </p>
    </div>

    <!-- Grid Layout -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
      <!-- Contactgegevens en Openingstijden -->
      <div class="flex flex-col justify-between">
        <!-- Openingstijden -->
        <div>
          <h3 class="text-3xl font-semibold mb-6">Openingstijden</h3>
          <ul class="text-lg space-y-1">
            <li
              v-for="(hours, day) in openingstijden"
              :key="day"
              :class="{'bg-sky-100 text-sky-800 px-2 py-1 rounded': isToday(day)}"
              class="flex justify-between items-center"
            >
              <span>{{ day }}</span>
              <span>{{ hours }}</span>
            </li>
          </ul>
        </div>

        <!-- Contactgegevens -->
        <div class="mt-8">
          <h3 class="text-3xl font-semibold mb-4">Onze Gegevens</h3>
          <ul class="space-y-4 text-lg">
            <li>
              <a
                href="https://www.google.com/maps/place/Marktstraat+123,+5678+AB+Vissersdorp"
                target="_blank"
                class="flex items-center hover:text-sky-400 transition"
              >
                <i class="fas fa-map-marker-alt text-sky-400 mr-2"></i>
                Heyhoefpromenade 81, 5043 RB Tilburg
              </a>
            </li>
            <li>
              <a
                href="tel:0135713106" 
                class="flex items-center hover:text-sky-400 transition"
              >
                <i class="fas fa-phone text-sky-400 mr-2"></i>
                013 5713106
              </a>
            </li>
            <li>
              <a
                href="mailto:info@visspecialistvanwijk.nl"
                class="flex items-center hover:text-sky-400 transition"
              >
                <i class="fas fa-envelope text-sky-400 mr-2"></i>
                info@visspecialistvanwijk.nl
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Kaart en Foto -->
      <div class="relative">
        <!-- Kaart -->
        <div class="h-full">
          <iframe
            class="rounded-xl shadow-lg w-full h-full"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2479.4905250897286!2d5.000986026967821!3d51.57757270557419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c69627e7ffa227%3A0xd89a5b5d950afd7c!2sHeyhoefpromenade%2081%2C%205043%20RB%20Tilburg!5e0!3m2!1snl!2snl!4v1735642072779!5m2!1snl!2snl"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <!-- Overliggende Foto -->
        <div class="absolute top-[-3rem] right-[-3rem] z-10 hidden xl:block w-48 h-48">
          <img
            src="/ext1.jpg"
            alt="Buitenkant van de winkel"
            class="rounded-xl shadow-md w-full h-full object-cover transform rotate-3 scale-95 hover:scale-100 transition"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      openingstijden: {
        Maandag: "Gesloten",
        Dinsdag: "09:00 - 18:00",
        Woensdag: "09:00 - 18:00",
        Donderdag: "09:00 - 18:00",
        Vrijdag: "09:00 - 20:00",
        Zaterdag: "09:00 - 17:00",
        Zondag: "Gesloten",
      },
    };
  },
  methods: {
    isToday(day) {
      const dagen = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag",
      ];
      const vandaag = new Date().getDay();
      return dagen[vandaag] === day;
    },
  },
};
</script>

<style scoped>
/* Responsive fixes voor overlappende afbeelding */
@media (max-width: 1024px) {
  .absolute {
    position: static !important;
    transform: none !important;
  }
}
</style>
